import type de from './locales/de';

export type TranslationKey = keyof typeof de;

export type TranslationVars = Record<string, string | number>;

export type Lang = 'de' | 'en' | 'fr' | 'es' | 'it' | 'nl' | 'pl';

export const SUPPORTED_LANGS: readonly Lang[] = ['de', 'en', 'fr', 'es', 'it', 'nl', 'pl'] as const;

export const DEFAULT_LANG: Lang = 'de';

export function isSupportedLang(value: string): value is Lang {
  return (SUPPORTED_LANGS as readonly string[]).includes(value);
}
